import {BASE_COLOR} from "@/utils/styles";

export function suffixSize(val: string | number | undefined): string {

    if (typeof val === 'number') {
        return `${val}px`
    } else {
        val = String(val)

        if (/^[\d]+$/.test(val)) {
            return `${val}px`
        }

        if (val.indexOf('px') > 0) {
            return val
        }

        return val
    }
}

export function flatten(array) {
    let flattend = [];
    (function flat(array) {
        array.forEach(function (el) {
            if (Array.isArray(el)) flat(el);
            else flattend.push(el);
        });
    })(array);
    return flattend;
}

export const DEFAULT_SIZE = {
    rect: [130, 40],
    ellipse: [100, 50],
    diamond: [140, 50],
    circle: [80, 80],
    triangle: [80, 80],
    star: [80, 80],
    activity: [200, 80],
    hexagon: [130, 50],
}

export const DEFAULT_MAX_CHART = {
    rect: 8,
    ellipse: 6,
    diamond: 6,
    circle: 6,
    triangle: 8,
    star: 6,
    activity: 12,
    hexagon: 8,
}

export function formatPos(option: { x: number, y: number, size: [number, number], shape: string }): { x: number, y: number, size: [number, number], shape } {

    const {x, y} = option
    option = {...option}
    option.size = option.size || DEFAULT_SIZE[option.shape]
    let [width, height] = option.size

    let originPos = {
        x: width / 2,
        y: height / 2,
    }
    let targetPos = {
        x, y
    }

    const grid = 5
    let durx = targetPos.x - originPos.x
    let dury = targetPos.y - originPos.y

    if (durx % grid > grid / 2) {
        durx = Math.ceil(durx / grid) * grid
    } else {
        durx = Math.floor(durx / grid) * grid
    }
    if (dury % grid > grid / 2) {
        dury = Math.ceil(dury / grid) * grid
    } else {
        dury = Math.floor(dury / grid) * grid
    }

    targetPos.x = durx + originPos.x
    targetPos.y = dury + originPos.y

    return {
        ...targetPos,
        size: option.size,
        shape: option.shape,
    }
}

/**
 * 计算显示的字符串
 * @param {string} str 要裁剪的字符串
 * @param {number} maxLen 最大字数
 */
export function fittingString(str, maxLen = 10) {
    const ellipsis = '…';
    if (str.length > maxLen) {
        return str.substring(0, maxLen) + ellipsis;
    }
    return str;
}

export function formatNodeModel(model, activityConfig, onlyRead=true) {
    let {shape, size, activity} = model

    if (!!activity) {
        shape = 'activity'
    }

    model.size = size || DEFAULT_SIZE[shape]

    if (!model.hasOwnProperty('data')) {
        model.data = {}
    }
    // 省略显示超长的文本
    if (onlyRead) {
        model.data.label = model.label
        model.label = fittingString(model.label, DEFAULT_MAX_CHART[shape]);
    } else {
        model.label = fittingString(model.data.label, DEFAULT_MAX_CHART[shape]);
    }

    if (!!activity && !!activityConfig[activity]) {
        model.shape = 'activity'
        model.img = activityConfig[activity].img
        model.color = activityConfig[activity].color
    }

    // 错误节点显示红色背景
    if (model.data.errors && model.data.errors.length > 0) {
        model.style = {
            fill: '#f56c6c',
            lineWidth: 0,
            stroke: BASE_COLOR,
            cursor: 'pointer',
        }
        model.labelCfg = {
            style: {
                fontSize: 14,
                fill: '#ffffff',
                cursor: 'pointer',
            }
        }
    } else {
        model.style = {
            fill: '#E8F1FF',
            lineWidth: 0,
            stroke: BASE_COLOR,
            cursor: 'pointer',
        }
        model.labelCfg = {
            style: {
                fontSize: 14,
                fill: BASE_COLOR,
                cursor: 'pointer',
            }
        }
    }
}
